// Renders the layer of Totem ON-AIR nodes (KMZ) on the map.
import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import { nodeIcon } from './mapAssets';

const NodesLayer = ({ nodes, onOpenDetail }) => {
  if (!nodes?.length) return null;
  return nodes.map((n) => (
    <Marker key={`node-${n.id}`} position={[n.lat, n.lng]} icon={nodeIcon(n.operator)}>
      <Popup>
        <div style={{ minWidth: 200 }}>
          <strong>{n.code}</strong>
          {n.alt_code && <span style={{ color: '#888' }}> · {n.alt_code}</span>}
          <div style={{ fontSize: 11, color: '#aaa', marginTop: 2 }}>
            {n.municipality}{n.muni_ine ? ` (INE ${n.muni_ine})` : ''}
          </div>
          <div style={{ fontSize: 11, marginTop: 4, color: '#fff' }}>
            <b style={{ color: '#A3FF12' }}>{n.type}</b> · {n.operator}<br/>
            {n.vendor && <>Vendor: <b>{n.vendor}</b><br/></>}
            {n.sedra_code && <>Sedra: <b>{n.sedra_code}</b></>}
          </div>
          <button onClick={() => onOpenDetail({ code: n.code, lat: n.lat, lng: n.lng })}
            data-testid={`btn-detail-${n.code}`}
            style={{ marginTop: 8, width: '100%', background: '#A3FF12', color: '#000', padding: '6px 10px', borderRadius: 6, fontWeight: 800, fontSize: 11, border: 'none', cursor: 'pointer' }}>
            Ver ficha completa →
          </button>
        </div>
      </Popup>
    </Marker>
  ));
};

export default React.memo(NodesLayer);
